import { collectionIdFromUrl } from "~/helpers/url_helpers"

export default class CollectionPathWatcher {
  private readonly onChange: (id: number) => void
  private currentId?: number

  constructor(callback: (id: number) => void) {
    this.onChange = callback
  }

  start(): void {
    this.onTurboLoad()
    document.addEventListener("turbo:load", this.onTurboLoad.bind(this))
  }

  stop(): void {
    document.removeEventListener("turbo:load", this.onTurboLoad.bind(this))
  }

  private onTurboLoad(): void {
    const newId = collectionIdFromUrl()
    if (newId && newId !== this.currentId) {
      this.currentId = newId
      this.onChange(newId)
    }
  }
}
